import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G filter="url(#filter0_d_5322_29876)">
      <Circle cx={20} cy={18} r={16} fill={props.bgColor || "white"} />
    </G>
    <Path
      d="M15.5991 23.6338L10.4218 19.1393C9.85939 18.651 9.85939 17.8623 10.4218 17.374C10.9843 16.8858 11.8928 16.8858 12.4552 17.374L16.623 20.9797L26.5448 12.3662C27.1072 11.8779 28.0157 11.8779 28.5782 12.3662C29.1406 12.8545 29.1406 13.6432 28.5782 14.1315L17.6324 23.6338C17.0844 24.1221 16.1615 24.1221 15.5991 23.6338Z"
      fill={props.color || "#00AB59"}
    />
    <Defs />
  </Svg>
);
export default SVGComponent;
